import { useEffect, useMemo, useState } from 'react';

import type { PipelineBoard, PipelineBoardSort } from '@/pages/pipelines/common/types';

import { getDefaultPipelineStage, sortPipelineBoardCards } from '../utils';

type Params = {
  board: PipelineBoard;
  sort?: PipelineBoardSort;
  activeOnly: boolean;
  isMobile: boolean;
};

export const usePipelineBoardColumns = ({ board, sort, activeOnly, isMobile }: Params) => {
  const sortedBoard = useMemo(() => sortPipelineBoardCards(board, sort), [board, sort]);
  const columns = useMemo(
    () =>
      activeOnly ? sortedBoard.columns.filter((column) => !column.terminal) : sortedBoard.columns,
    [activeOnly, sortedBoard.columns],
  );
  const [expandedStage, setExpandedStage] = useState(() => getDefaultPipelineStage(columns));
  const renderedColumns = useMemo(
    () => (isMobile ? columns.filter((column) => column.stage === expandedStage) : columns),
    [columns, expandedStage, isMobile],
  );

  useEffect(() => {
    if (!columns.some((column) => column.stage === expandedStage)) {
      setExpandedStage(getDefaultPipelineStage(columns));
    }
  }, [columns, expandedStage]);

  return {
    columns,
    renderedColumns,
    expandedStage,
    setExpandedStage,
  };
};
